import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import kkbwealthLogo from '../../assests/kkbwealthbg.png';

const C = {
  bgDark: '#0B5867',   // Deep Teal
  bgMid: '#2B6873',   // Mid Teal
  bgLight: '#9FBCC0',   // Mist
  accent: '#FF8C7A',   // Coral
  success: '#4ade80',   // Green
  danger: '#ef4444',   // Red
  white: '#FFFFFF',
  textSecondary: '#E2E8F0',
  glass: 'rgba(255, 255, 255, 0.08)',
  border: 'rgba(255, 255, 255, 0.15)',
};



const Header = () => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <header style={{
        position: 'fixed', top: 0, width: '100%', zIndex: 1000,
        padding: scrolled ? '15px 0' : '30px 0',
        background: scrolled ? 'rgba(11, 88, 103, 0.95)' : 'transparent',
        backdropFilter: scrolled ? 'blur(15px)' : 'none',
        transition: 'all 0.4s ease',
        borderBottom: scrolled ? `1px solid ${C.border}` : 'none'
      }}>
        <div style={{ maxWidth: 1300, margin: '0 auto', padding: '0 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div
            onClick={() => navigate('/home')}
            style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer' }}
          >
            <img src={kkbwealthLogo} alt="KKB Wealth Logo" style={{ height: '45px', background: 'transparent' }} />
          </div>

          <nav style={{ display: 'flex', gap: '40px' }} className="hide-mobile">
            <Link to="/aboutus" className="nav-link">About</Link>
            <Link to="/insights" className="nav-link">Insights</Link>
            <Link to="/contactus" className="nav-link">Contact</Link>
          </nav>

          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <button className="hide-mobile" onClick={() => navigate('/getintouch')} style={{
              background: C.accent, color: C.bgDark, border: 'none', padding: '12px 28px', borderRadius: '30px', fontWeight: 700, cursor: 'pointer'
            }}>Get Started</button>
            <button
              className="show-mobile"
              onClick={() => setMobileMenuOpen(true)}
              style={{ background: 'none', border: 'none', color: C.white, cursor: 'pointer' }}
            >
              <Menu size={28} color="#FFFFFF" />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Drawer */}
      <div style={{
        position: 'fixed', top: 0, right: 0, bottom: 0, width: '100%',
        background: C.bgDark, zIndex: 2000, padding: '40px', boxSizing: 'border-box',
        transform: mobileMenuOpen ? 'translateX(0)' : 'translateX(100%)',
        transition: 'transform 0.4s ease-in-out',
        display: 'flex', flexDirection: 'column', gap: '30px'
      }}>
        <button onClick={() => setMobileMenuOpen(false)} style={{ alignSelf: 'flex-end', background: 'none', border: 'none', color: C.white, cursor: 'pointer' }}><X size={32} /></button>

        <Link to="/home" onClick={() => setMobileMenuOpen(false)} style={{ color: C.white, fontSize: '1.5rem', textDecoration: 'none', fontWeight: 700 }}>Home</Link>
        <Link to="/aboutus" onClick={() => setMobileMenuOpen(false)} style={{ color: C.white, fontSize: '1.5rem', textDecoration: 'none', fontWeight: 700 }}>About</Link>
        <Link to="#" onClick={() => setMobileMenuOpen(false)} style={{ color: C.white, fontSize: '1.5rem', textDecoration: 'none', fontWeight: 700 }}>Portfolio</Link>
        <Link to="/insights" onClick={() => setMobileMenuOpen(false)} style={{ color: C.white, fontSize: '1.5rem', textDecoration: 'none', fontWeight: 700 }}>Insights</Link>
        <Link to="/contactus" onClick={() => setMobileMenuOpen(false)} style={{ color: C.white, fontSize: '1.5rem', textDecoration: 'none', fontWeight: 700 }}>Contact</Link>

        <button onClick={() => { navigate('/contactus'); setMobileMenuOpen(false); }} style={{ background: C.accent, color: C.bgDark, border: 'none', padding: '20px', borderRadius: '15px', fontWeight: 700, marginTop: '20px', cursor: 'pointer' }}>Get Started</button>
      </div>
    </>
  );
};

export default Header;
